import './checkbox-button.sass'
// import { useSlots } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        label: {
            type: String,
            default: '',
        },
        checked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        id: {
            type: Number,
            default: 0,
        }
    },

    setup(props, { slots }) {
        // const slots = useSlots()
        return () => {
            return (
                <div class={`catalog-custom-checkbox-button ${props.disabled ? 'is-disabled' : ''}`}>
                    <input class="custom-check-input" disabled={props.disabled} type="checkbox" name="input" value={props.id} checked={props.checked} />
                    <div class="catalog-custom-checkbox-button-box"></div>
                    <label onClick={(e) => e.stopPropagation()} for={props.label}>
                        {slots.default &&
                            <span class="catalog-custom-checkbox-button-span">{
                                slots.default()
                            }
                            </span>
                        }
                    </label>
                </div>
            )
        }
    }
})


